import {
  Copy,
  Ellipsis,
  Forward,
  Link,
  ListPlus,
  ListTree,
  Plus,
  Trash2,
} from "lucide-react";

import DeleteDialog from "@/shared/components/modals/delete-modal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";

import EditableNameInput from "@/shared/components/ui/editable-name-input";

import { ISpecificationCategoryResponse } from "@/shared/services/interface/responses/ISpecificationResponse";
import CollapsibleItemMenuViewModel from "./collapsible-item-menu-view-model";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "@/core/redux/store";
import { setIsCategoryEditInputFocused } from "@/core/redux/slices/input";
import { Card } from "@/shared/components/ui/card";
export default function CollapsibleItemMenuView({
  item,
  updateCategory,
  handleAddNewItem,
  isOpen,
  isCategoryActive = false,
}: {
  item: ISpecificationCategoryResponse;
  priority: string;
  updateCategory: (id: string, name: string) => void;
  handleAddNewItem: (focus?: boolean) => void;
  isOpen: boolean;
  isCategoryActive?: boolean;
}) {
  const {
    isDeleteOpen,
    setIsDeleteOpen,
    addNewCategory,
    handleDeleteCategory,
  } = CollapsibleItemMenuViewModel({
    item,
  });

  const [categoryInputFocused, setCategoryInputFocused] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [plusDropdownOpen, setPlusDropdownOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleDropdownOpenChange = (open: boolean) => {
    // Eğer dropdown kapanmaya çalışıyorsa, parent element'e tıklanmış olabilir
    if (!open) {
      // Kısa bir delay ile kontrol et
      setTimeout(() => {
        const activeElement = document.activeElement as HTMLElement;
        const clickedElement =
          activeElement || (document.querySelector(":active") as HTMLElement);

        // Eğer parent element'lere tıklanmışsa, dropdown'u açık tut
        if (
          clickedElement?.closest(".category-menu-button") ||
          clickedElement?.closest(".category-group") ||
          clickedElement?.closest(".category-input-overlay") ||
          clickedElement?.closest(".hover-group-" + item.id) ||
          clickedElement?.closest(".item-menu-action")
        ) {
          setDropdownOpen(true);
          return;
        }
      }, 10);
    }
    setDropdownOpen(open);
  };

  const handlePlusDropdownOpenChange = (open: boolean) => {
    // Eğer dropdown kapanmaya çalışıyorsa, parent element'e tıklanmış olabilir
    if (!open) {
      // Kısa bir delay ile kontrol et
      setTimeout(() => {
        const activeElement = document.activeElement as HTMLElement;
        const clickedElement =
          activeElement || (document.querySelector(":active") as HTMLElement);

        // Eğer parent element'lere tıklanmışsa, dropdown'u açık tut
        if (
          clickedElement?.closest(".category-menu-button") ||
          clickedElement?.closest(".category-group") ||
          clickedElement?.closest(".category-input-overlay") ||
          clickedElement?.closest(".hover-group-" + item.id) ||
          clickedElement?.closest(".item-menu-action")
        ) {
          setPlusDropdownOpen(true);
          return;
        }
      }, 10);
    }
    setPlusDropdownOpen(open);
  };

  return (
    <div
      className={`item-menu-action flex gap-0.5 items-center justify-center absolute right-[10px] ${
        isCategoryActive ? "visible" : "invisible hover-target-${item.id}"
      } transition-opacity duration-300`}
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownMenu
        open={dropdownOpen}
        onOpenChange={handleDropdownOpenChange}
        modal={false}
      >
        <DropdownMenuTrigger asChild>
          <Card
            className={`w-[18px] border-none ring-0 shadow-none  ${
              isCategoryActive ? "bg-secondary" : "bg-transparent"
            } h-[18px] flex items-center justify-center py-0.5 px-0.5 rounded-sm  focus:bg-secondary hover:bg-[#e5e4e7]`}
          >
            <Ellipsis width="16px" height="16px" />
          </Card>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[190px]  p-1 cursor-pointer bg-white rounded-xl  shadow-md "
          onEscapeKeyDown={(e) => {
            // Escape tuşuna basıldığında kapat
            setDropdownOpen(false);
          }}
          onInteractOutside={(e) => {
            const target = e.target as HTMLElement;
            // Dropdown içindeki elementlere tıklanınca kapatma
            if (
              target.closest('[role="menu"]') ||
              target.closest('[role="menuitem"]')
            ) {
              e.preventDefault();
              return;
            }
            // Menu action container'a tıklanınca kapatma
            if (target.closest(".item-menu-action")) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setDropdownOpen(true), 0);
              return;
            }
            // SidebarMenuButton veya category-group'a tıklanınca kapatma
            if (
              target.closest(".category-menu-button") ||
              target.closest(".category-group") ||
              target.closest(".category-input-overlay") ||
              target.closest(".hover-group-" + item.id)
            ) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setDropdownOpen(true), 0);
              return;
            }
            // Input focused ise önce focus'u kaldır
            if (categoryInputFocused) {
              e.preventDefault();
              setCategoryInputFocused(false);
              dispatch(setIsCategoryEditInputFocused(false));
            }
          }}
          onPointerDownOutside={(e) => {
            const target = e.target as HTMLElement;
            // Dropdown içindeki elementlere tıklanınca kapatma
            if (
              target.closest('[role="menu"]') ||
              target.closest('[role="menuitem"]')
            ) {
              e.preventDefault();
              return;
            }
            // Menu action container'a tıklanınca kapatma
            if (target.closest(".item-menu-action")) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setDropdownOpen(true), 0);
              return;
            }
            // SidebarMenuButton veya category-group'a tıklanınca kapatma
            if (
              target.closest(".category-menu-button") ||
              target.closest(".category-group") ||
              target.closest(".category-input-overlay") ||
              target.closest(".hover-group-" + item.id)
            ) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setDropdownOpen(true), 0);
              return;
            }
            // Input focused ise önce focus'u kaldır
            if (categoryInputFocused) {
              e.preventDefault();
              setCategoryInputFocused(false);
              dispatch(setIsCategoryEditInputFocused(false));
            }
          }}
        >
          <DropdownMenuGroup className="cursor-pointer">
            <EditableNameInput
              className="py-[6px] px-[5px]"
              initialValue={item.name}
              placeholder={t("category-name")}
              onSave={(newValue) => updateCategory(item.id, newValue)}
              onFocusChange={(focused) => {
                setCategoryInputFocused(focused);
                dispatch(setIsCategoryEditInputFocused(focused));
              }}
              preventDropdownClose={dropdownOpen}
            />
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="cursor-pointer text-sm font-500 "
              onClick={() => {}}
            >
              <Link width="16px" height="16px" />
              {t("copy-link")}
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer text-sm font-500 "
              onClick={() => {}}
            >
              <Copy width="16px" height="16px" />
              {t("copy-category")}
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer text-sm font-500 "
              onClick={() => {}}
            >
              <Forward width="16px" height="16px" />
              {t("move-to")}
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer text-sm font-500 "
            onClick={() => setIsDeleteOpen(true)}
          >
            <Trash2 width="16px" height="16px" />
            {t("delete")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu
        open={plusDropdownOpen}
        onOpenChange={handlePlusDropdownOpenChange}
        modal={false}
      >
        <DropdownMenuTrigger asChild>
          <Card
            className={`w-[18px] border-none ring-0 shadow-none  ${
              isCategoryActive ? "bg-secondary" : "bg-transparent"
            } h-[18px] flex items-center justify-center py-0.5 px-0.5 rounded-sm  focus:bg-secondary hover:bg-[#e5e4e7]`}
          >
            <Plus width={16} height={16} />
          </Card>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[190px]  p-1 cursor-pointer bg-white rounded-xl  shadow-md "
          onEscapeKeyDown={(e) => {
            // Escape tuşuna basıldığında kapat
            setPlusDropdownOpen(false);
          }}
          onInteractOutside={(e) => {
            const target = e.target as HTMLElement;
            // Dropdown içindeki elementlere tıklanınca kapatma
            if (
              target.closest('[role="menu"]') ||
              target.closest('[role="menuitem"]')
            ) {
              e.preventDefault();
              return;
            }
            // Menu action container'a tıklanınca kapatma
            if (target.closest(".item-menu-action")) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setPlusDropdownOpen(true), 0);
              return;
            }
            // SidebarMenuButton veya category-group'a tıklanınca kapatma
            if (
              target.closest(".category-menu-button") ||
              target.closest(".category-group") ||
              target.closest(".category-input-overlay") ||
              target.closest(".hover-group-" + item.id)
            ) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setPlusDropdownOpen(true), 0);
              return;
            }
          }}
          onPointerDownOutside={(e) => {
            const target = e.target as HTMLElement;
            // Dropdown içindeki elementlere tıklanınca kapatma
            if (
              target.closest('[role="menu"]') ||
              target.closest('[role="menuitem"]')
            ) {
              e.preventDefault();
              return;
            }
            // Menu action container'a tıklanınca kapatma
            if (target.closest(".item-menu-action")) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setPlusDropdownOpen(true), 0);
              return;
            }
            // SidebarMenuButton veya category-group'a tıklanınca kapatma
            if (
              target.closest(".category-menu-button") ||
              target.closest(".category-group") ||
              target.closest(".category-input-overlay") ||
              target.closest(".hover-group-" + item.id)
            ) {
              e.preventDefault();
              // Dropdown'u açık tut
              setTimeout(() => setPlusDropdownOpen(true), 0);
              return;
            }
          }}
        >
          <DropdownMenuGroup className="cursor-pointer">
            <DropdownMenuItem
              className="cursor-pointer text-sm font-500 "
              onClick={() => {
                handleAddNewItem(true);
              }}
            >
              <ListPlus width="16px" height="16px" />
              {t("add-requirement")}
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer text-sm font-500 "
              onClick={() => {
                addNewCategory(item.id);
              }}
            >
              <ListTree width="16px" height="16px" />
              {t("add-category")}
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <DeleteDialog
        isOpen={isDeleteOpen}
        showActionToggle={setIsDeleteOpen}
        confirmFunction={handleDeleteCategory}
      />
    </div>
  );
}
